<template>
    <form-wizard
        color="#7367f0"
        :title="null"
        :subtitle="null"
        finish-button-text="Сохранить"
        next-button-text="Далее"
        back-button-text="Назад"
        class="steps-transparent"
        @on-complete="() => submitAction()"
    >
        <tab-content
        icon="feather icon-file-text"
        title="Общие"
        :before-change="()=> validateForm(steps['step_1'].value)"
    >
        <validation-observer
                ref="step_1"
                tag="form"
        >

            <b-form-group
                label="Номер"
                label-size="sm"
                class="flex-grow-1"
                description="Укажите номер"
            >
                <validation-provider
                        #default="{ errors }"
                        name="number"
                        rules="required"
                >
                    <b-form-input
                            class="w-100"
                            v-model="formModel['number']"
                            :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
            <b-form-group
                label="Тип обьекта"
                label-size="sm"
                class="flex-grow-1"
                description="Укажите тип обьекта"
            >
                <validation-provider
                        #default="{ errors }"
                        name="object_type"
                        rules="required"
                >
                    <choose-object-type-field
                            v-model="formModel['object_type']"
                            @input="val=>formModel['object_type']=val"
                    ></choose-object-type-field>
                    <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>
        </validation-observer>
    </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Платформа"
                :before-change="()=> validateForm(steps['step_2'].value)"
        >
            <validation-observer
                    ref="step_2"
                    tag="form"
            >
                <b-form-group
                    label="Участок"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите участок"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="railway_sector"
                    >

                        <choose-sector-field
                                v-model="formModel['railway_sector']"
                                @input="val=>formModel['railway_sector']=val"
                        ></choose-sector-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Станция"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите станцию"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="station"
                    >

                        <choose-station-field
                                v-model="formModel['station']"
                                @input="val=>formModel['station']=val"
                        ></choose-station-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Платформа"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите платформу"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="platform"
                    >
                        <choose-platform-field
                                v-model="formModel['platform']"
                                @input="val=>formModel['platform']=val"
                        ></choose-platform-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title="Пользователь"
                :before-change="()=> validateForm(steps['step_3'].value)"
        >
            <validation-observer
                    ref="step_3"
                    tag="form"
            >
                <b-form-group
                    label="Пользователь"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите пользователя"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="user"
                            rules="required"
                    >
                        <choose-user-field
                                v-model="formModel['user']"
                                @input="val=>formModel['user']=val"
                        ></choose-user-field>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
        <tab-content
                icon="feather icon-file-text"
                title=" Местоположение"
                :before-change="()=> validateForm(steps['step_4'].value)"
        >
            <validation-observer
                    ref="step_4"
                    tag="form"
            >
                <b-form-group
                    label="Широта"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите широту"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="lat"
                            rules="required|double"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['geolocation']['point']['lat']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Долгота"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите долготу"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="long"
                            rules="required|double"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['geolocation']['point']['long']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Пикет"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите пикет"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="picket"
                            rules="required|double"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['geolocation']['geo_addition']['picket']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Км"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите км"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="km"
                            rules="required|double"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['geolocation']['geo_addition']['km']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
                <b-form-group
                    label="Номер пути"
                    label-size="sm"
                    class="flex-grow-1"
                    description="Укажите номер пути"
                >
                    <validation-provider
                            #default="{ errors }"
                            name="path"
                            rules="required|double"
                    >
                        <b-form-input
                                class="w-100"
                                v-model="formModel['geolocation']['geo_addition']['path']"
                                :state="errors.length > 0 ? false:null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </validation-observer>
        </tab-content>
    </form-wizard>
</template>


<script>
    import {ref} from '@vue/composition-api'

    import {BContainer, BRow, BCol, BForm, BFormGroup, BFormInput, BFormCheckbox} from 'bootstrap-vue'

    import { FormWizard, TabContent } from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    import { STORE_MODULE_NAME } from '@/views/apps/railway_structure/pillar/pillarStoreModule'
    import usePillar from '@/views/apps/railway_structure/pillar/usePillar'

    import { validateForm } from '@core/utils/validations/utils'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required, double } from '@validations'


    import useAppElementListAddNew from "@core/components/app-elements/appElementListAddNew/useAppElementListAddNew";
    import ChooseUserField from "@/views/apps/user/components/ChooseUserField";
    import ChoosePlatformField from "@/views/apps/railway_structure/platform/components/ChoosePlatformField";
    import ChooseObjectTypeField from "@/views/apps/infrastructure/object_type/components/ChooseObjectTypeField";
    import ChooseStationField from "@/views/apps/railway_structure/station/components/ChooseStationField";
    import ChooseSectorField from "@/views/apps/railway_structure/sector/components/ChooseSectorField";


    export default {

        components:{
            ChooseSectorField,
            ChooseStationField,
            ChooseObjectTypeField,
            ChoosePlatformField,
            ChooseUserField,
            BContainer, BRow, BCol,
            FormWizard, TabContent,
            BForm, BFormGroup, BFormInput, BFormCheckbox,

            ValidationProvider, ValidationObserver
        },

        setup() {

            const {
                addDataUrl,
                setupData,
            } = usePillar();

            const {
                formModel,
                submitAction,
            } = useAppElementListAddNew({
                storeModuleName: STORE_MODULE_NAME,
                addDataUrl: addDataUrl,
                ...setupData,
            })


            const steps = {
                step_1:ref(null),
                step_2:ref(null),
                step_3:ref(null),
                step_4:ref(null),
            }


            return {
                submitAction,
                formModel,

                steps, ...steps,
                validateForm,
            }
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
</style>

